import React, { useState, useEffect } from 'react';
import TeleVerificationList from './TeleVerificationList';
import { useNavigate } from 'react-router-dom';
import { saveFileComponentValues, submitFileComponentValues } from '../../../services/client/customerApiService';
import Swal from "sweetalert2";
import { ProcessingOverlay } from '../../common/ProcessingOverlay';
import axios from 'axios';
import {  FaPaperclip } from 'react-icons/fa';
const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`;
const getAuthKey = () => {
  return `${process.env.REACT_APP_API_SECURITY_KEY}`;
};

const DynamicForm_TE = ({ fileId, onSubmit, selectedFileDetails }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const navigate = useNavigate();
  const [fields, setFields] = useState([]);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [responseData, setResponseData] = useState({});
  const [teleLogs, setTeleLogs] = useState([
    {
      attempt: "1st",
      resi_date: "",
      resi_time: "",
      resi_outcome: "",
      office_date: "",
      office_time: "",
      office_outcome: "",
    },
    {
      attempt: "2nd",
      resi_date: "",
      resi_time: "",
      resi_outcome: "",
      office_date: "",
      office_time: "",
      office_outcome: "",
    },
    {
      attempt: "3rd",
      resi_date: "",
      resi_time: "",
      resi_outcome: "",
      office_date: "",
      office_time: "",
      office_outcome: "",
    }
  ]);

  const [postTeleLogs, setPostTeleLogs] = useState([
    {
      attempt: "1st",
      resi_date: "",
      resi_time: "",
      resi_outcome: "",
      office_date: "",
      office_time: "",
      office_outcome: "",
    },
    {
      attempt: "2nd",
      resi_date: "",
      resi_time: "",
      resi_outcome: "",
      office_date: "",
      office_time: "",
      office_outcome: "",
    },
    {
      attempt: "3d",
      resi_date: "",
      resi_time: "",
      resi_outcome: "",
      office_date: "",
      office_time: "",
      office_outcome: "",
    },
    {
      attempt: "4th",
      resi_date: "",
      resi_time: "",
      resi_outcome: "",
      office_date: "",
      office_time: "",
      office_outcome: "",
    }
  ]);

  const emptyTeleLogs = [
    {
      attempt: "1st",
      resi_date: "",
      resi_time: "",
      resi_outcome: "",
      office_date: "",
      office_time: "",
      office_outcome: "",
    },
    {
      attempt: "2nd",
      resi_date: "",
      resi_time: "",
      resi_outcome: "",
      office_date: "",
      office_time: "",
      office_outcome: "",
    },
    {
      attempt: "3d",
      resi_date: "",
      resi_time: "",
      resi_outcome: "",
      office_date: "",
      office_time: "",
      office_outcome: "",
    }
  ];

  const emptyPostTeleLogs = [
    {
      attempt: "1st",
      resi_date: "",
      resi_time: "",
      resi_outcome: "",
      office_date: "",
      office_time: "",
      office_outcome: "",
    },
    {
      attempt: "2nd",
      resi_date: "",
      resi_time: "",
      resi_outcome: "",
      office_date: "",
      office_time: "",
      office_outcome: "",
    },
    {
      attempt: "3d",
      resi_date: "",
      resi_time: "",
      resi_outcome: "",
      office_date: "",
      office_time: "",
      office_outcome: "",
    },
    {
      attempt: "4th",
      resi_date: "",
      resi_time: "",
      resi_outcome: "",
      office_date: "",
      office_time: "",
      office_outcome: "",
    }
  ];


  // Fetch dynamic fields from the backend
  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/verificationFields/${fileId}`, {
      headers: {
        'auth_key': `${getAuthKey()}`,
      },
    }) // Replace with your backend endpoint
      .then(response => {
        const { data } = response;
        if (data.statusCode === 1001 && data.result.component) {
          setResponseData(data.result);
          const formFields = data.result.component.formFields;

          // Set fields for rendering the form
          setFields(formFields);
          // Parse the JSON string into an object/array
          var parsedTeleLogs = emptyTeleLogs;
          if(data.result.component.teleLogsPre_Json){
            parsedTeleLogs = JSON.parse(data.result.component.teleLogsPre_Json);
        }
          // Update the state
          setTeleLogs(parsedTeleLogs ? parsedTeleLogs : emptyTeleLogs);

          // Parse the JSON string into an object/array
          var parsedPostTeleLogs = emptyPostTeleLogs;
          if(data.result.component.teleLogsPost_Json){
            parsedPostTeleLogs = JSON.parse(data.result.component.teleLogsPost_Json);
        }
          // Update the state
          setPostTeleLogs(parsedPostTeleLogs ? parsedPostTeleLogs : emptyPostTeleLogs);
          // Initialize form data state
          /*const initialFormData = {};
          formFields.forEach((field) => {
            initialFormData[field.fieldName] = field.value || ""; // Default to an empty string if no value
          });
          setFormData(initialFormData);*/

          // Set the entire result object as the formData
          setFormData(data.result);
        } else {
          console.error("Invalid response structure", response);
        }
      })
      .catch((error) => {
        console.error("Error fetching fields:", error);
      });
  }, []);

  // Handle form field changes
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({ ...formData, [name]: value });
  // };

  const handleChange = (e, index) => {
    const { name, value } = e.target;

    setFormData((prevData) => {
      const updatedFields = [...prevData.component.formFields];
      updatedFields[index] = { ...updatedFields[index], value };

      return {
        ...prevData,
        component: {
          ...prevData.component,
          formFields: updatedFields,
        },
      };
    });
  };


  const addLog = () => {
    const attemptNumber = teleLogs.length + 1;
    const suffix =
      attemptNumber === 1
        ? "1st"
        : attemptNumber === 2
          ? "2nd"
          : attemptNumber === 3
            ? "3rd"
            : `${attemptNumber}th`;

    setTeleLogs((prevLogs) => [
      ...prevLogs,
      {
        attempt: suffix,
        resi_date: "",
        resi_time: "",
        resi_outcome: "",
        office_date: "",
        office_time: "",
        office_outcome: "",
      },
    ]);
  };

  const deleteLog = (index) => {
    setTeleLogs((prevLogs) => {
      const updatedLogs = prevLogs.filter((_, logIndex) => logIndex !== index);

      // Update formData to reflect the deleted teleLog
      setFormData((prevFormData) => ({
        ...prevFormData,
        component: {
          ...prevFormData.component,
          teleLogsPre_Json: updatedLogs.length > 0 ? JSON.stringify(updatedLogs) : [],
        },
      }));

      return updatedLogs;
    });
  };


  // Handle tele-calling log changes
  const handleTeleLogChange = (index, e) => {
    const { name, value } = e.target;
    const updatedLogs = [...teleLogs];
    updatedLogs[index][name] = value;
    setTeleLogs(updatedLogs);
    // Update formData to reflect the deleted teleLog
    setFormData((prevFormData) => ({
      ...prevFormData,
      component: {
        ...prevFormData.component,
        teleLogsPre_Json: updatedLogs.length > 0 ? JSON.stringify(updatedLogs) : [],
      },
    }));
  };

  const addPostLog = () => {
    const attemptNumber = postTeleLogs.length + 1;
    const suffix =
      attemptNumber === 1
        ? "1st"
        : attemptNumber === 2
          ? "2nd"
          : attemptNumber === 3
            ? "3rd"
            : `${attemptNumber}th`;

    setPostTeleLogs((prevLogs) => [
      ...prevLogs,
      {
        attempt: suffix,
        resi_date: "",
        resi_time: "",
        resi_outcome: "",
        office_date: "",
        office_time: "",
        office_outcome: "",
      },
    ]);
  };

  const deletePostLog = (index) => {
    setPostTeleLogs((prevLogs) => {
      const updatedPostLogs = prevLogs.filter((_, logIndex) => logIndex !== index);

      // Update formData to reflect the deleted teleLog
      setFormData((prevFormData) => ({
        ...prevFormData,
        component: {
          ...prevFormData.component,
          teleLogsPost_Json: updatedPostLogs.length > 0 ? JSON.stringify(updatedPostLogs) : [],
        },
      }));

      return updatedPostLogs;
    });
  };


  // Handle tele-calling log changes
  const handlePostTeleLogChange = (index, e) => {
    const { name, value } = e.target;
    const updatedPostLogs = [...postTeleLogs];
    updatedPostLogs[index][name] = value;
    setPostTeleLogs(updatedPostLogs);
    setFormData((prevFormData) => ({
      ...prevFormData,
      component: {
        ...prevFormData.component,
        teleLogsPost_Json: updatedPostLogs.length > 0 ? JSON.stringify(updatedPostLogs) : [],
      },
    }));
  };

  // Recalculate visibility based on formData updates
  const isFieldVisible = (field) => {
    if (!field.dependsOnFieldId) return true;
    const dependsOnField = fields.find((f) => f.fieldId === field.dependsOnFieldId);
    return dependsOnField && formData[dependsOnField.fieldName] === field.dependsOnValue;
  };

  useEffect(() => {
    // Trigger re-render by updating the fields array with visibility state
    setFields((prevFields) =>
      prevFields.map((field) => ({
        ...field,
        isVisible: isFieldVisible(field),
      }))
    );
  }, [formData]); // Recalculate when formData changes

  // Submit the form
  const handleSave = async (e) => {
    e.preventDefault();
    setIsProcessing(true);
    // Safely parse and update teleLogsPre_Json
    let updatedteleLogsPre_Json;

    try {
      // Safely parse existing teleLogsPre_Json or initialize it as an empty array if it's null/undefined
      updatedteleLogsPre_Json = formData.component?.teleLogsPre_Json
        ? JSON.parse(formData.component.teleLogsPre_Json)
        : [];
    } catch (error) {
      console.error("Error parsing teleLogsPre_Json:", error);
      //console.log("Resetting teleLogsPre_Json to an empty array.");
      updatedteleLogsPre_Json = null; // Reset to empty array if JSON parsing fails
    }

    // Append new teleLogs data to the existing array (do not stringify each entry)
    updatedteleLogsPre_Json = [...updatedteleLogsPre_Json, ...teleLogs];
    if (updatedteleLogsPre_Json.length === 0) {
      updatedteleLogsPre_Json = null;
    } else {
      // Update formData with the updated teleLogsPre_Json
      
      setFormData((prevFormData) => ({
        ...prevFormData,
        component: {
          ...prevFormData.component,
          teleLogsPre_Json: JSON.stringify(updatedteleLogsPre_Json),
        },
      }));
    }

    // Safely parse and update teleLogsPre_Json
    let updatedteleLogsPost_Json;

    try {
      // Safely parse existing teleLogsPre_Json or initialize it as an empty array if it's null/undefined
      updatedteleLogsPost_Json = formData.component?.teleLogsPost_Json
        ? JSON.parse(formData.component.teleLogsPost_Json)
        : [];
    } catch (error) {
      console.error("Error parsing teleLogsPre_Json:", error);
      //console.log("Resetting teleLogsPre_Json to an empty array.");
      updatedteleLogsPost_Json = null; // Reset to empty array if JSON parsing fails
    }

    // Append new teleLogs data to the existing array (do not stringify each entry)
    updatedteleLogsPost_Json = [...updatedteleLogsPost_Json, ...postTeleLogs];
    if (updatedteleLogsPost_Json.length === 0) {
      updatedteleLogsPost_Json = null;
    } else {
      // Update formData with the updated teleLogsPre_Json
      setFormData((prevFormData) => ({
        ...prevFormData,
        component: {
          ...prevFormData.component,
          teleLogsPost_Json: JSON.stringify(updatedteleLogsPost_Json),
        },
      }));

      // Update state
      //setFormData(updatedFormData);
    }
    //console.log("Updated FormData before submission:", formData);
    try {
      //console.log('Form submitted', formData);
      const data = await saveFileComponentValues(formData);

      //console.log(data);
      if (!data.error) {
        // alert("Success");
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Successfully Saved",
          confirmButtonColor: "#4CAF50",
        }).then(() => {
          onSubmit();
        });
      } else {
        Swal.fire({
                  icon: "error",
                  title: "Error!",
                  text: data.error,
                  confirmButtonColor: "#4CAF50",
                }).then(() => {
                  return;
                });
      }
    } catch (err) {
      //alert( 'Failed to submit form. Please try again.');
      Swal.fire("Error", 'Failed to submit form. Please try again.', "error");
    } finally {
      setIsProcessing(false);
    }
  };

  const validateForm = () => {
    let newErrors = {};

    formData.component.formFields.forEach((field, index) => {
      if (field.required && (!field.value || field.value.trim() === "")) {
        newErrors[field.fieldName] = `${field.fieldLabel} is required`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return; // Stop submission if validation fails
    }
    setIsProcessing(true);
    // Safely parse and update teleLogsPre_Json
    let updatedteleLogsPre_Json;

    try {
      // Safely parse existing teleLogsPre_Json or initialize it as an empty array if it's null/undefined
      updatedteleLogsPre_Json = formData.component?.teleLogsPre_Json
        ? JSON.parse(formData.component.teleLogsPre_Json)
        : [];
    } catch (error) {
      console.error("Error parsing teleLogsPre_Json:", error);
      //console.log("Resetting teleLogsPre_Json to an empty array.");
      updatedteleLogsPre_Json = null; // Reset to empty array if JSON parsing fails
    }

    // Append new teleLogs data to the existing array (do not stringify each entry)
    updatedteleLogsPre_Json = [...updatedteleLogsPre_Json, ...teleLogs];
    if (updatedteleLogsPre_Json==null || updatedteleLogsPre_Json.length === 0) {
      updatedteleLogsPre_Json = JSON.stringify(emptyTeleLogs);
    } else {
      // Update formData with the updated teleLogsPre_Json
      setFormData((prevFormData) => ({
        ...prevFormData,
        component: {
          ...prevFormData.component,
          teleLogsPre_Json: JSON.stringify(updatedteleLogsPre_Json),
        },
      }));
    }

    // Safely parse and update teleLogsPre_Json
    let updatedteleLogsPost_Json;

    try {
      // Safely parse existing teleLogsPre_Json or initialize it as an empty array if it's null/undefined
      updatedteleLogsPost_Json = formData.component?.teleLogsPost_Json
        ? JSON.parse(formData.component.teleLogsPost_Json)
        : [];
    } catch (error) {
      console.error("Error parsing teleLogsPre_Json:", error);
      //console.log("Resetting teleLogsPre_Json to an empty array.");
      updatedteleLogsPost_Json = null; // Reset to empty array if JSON parsing fails
    }

    // Append new teleLogs data to the existing array (do not stringify each entry)
    updatedteleLogsPost_Json = [...updatedteleLogsPost_Json, ...postTeleLogs];
    if (updatedteleLogsPost_Json==null || updatedteleLogsPost_Json.length === 0) {
      updatedteleLogsPost_Json = JSON.stringify(emptyPostTeleLogs);
    } else {
      // Update formData with the updated teleLogsPre_Json
      setFormData((prevFormData) => ({
        ...prevFormData,
        component: {
          ...prevFormData.component,
          teleLogsPost_Json: JSON.stringify(updatedteleLogsPost_Json),
        },
      }));

      // Update state
      //setFormData(updatedFormData);
    }
    //console.log("Updated FormData before submission:", formData);
    try {
      // console.log('Form submitted', formData);
      const data = await submitFileComponentValues(formData);

      //console.log(data);
      if (!data.error) {
        // alert("Success");
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Successfully Submitted",
          confirmButtonColor: "#4CAF50",
        }).then(() => {
          onSubmit();
        });

      } else {
        Swal.fire({
                  icon: "error",
                  title: "Error!",
                  text: data.error,
                  confirmButtonColor: "#4CAF50",
                }).then(() => {
                  return;
                });
      }
    } catch (err) {
      //alert( 'Failed to submit form. Please try again.');
      Swal.fire("Error", 'Failed to submit form. Please try again.', "error");
    } finally {
      setIsProcessing(false);
    }
  };
  const handleCheckboxChange = (e, index) => {
    const { value, checked } = e.target;
    const currentValue = formData.component.formFields[index].value || "";

    let newValue;
    if (checked) {
      // Add the new value to the current value, ensuring values are comma-separated
      newValue = currentValue ? `${currentValue},${value}` : value;
    } else {
      // Remove the value if unchecked
      newValue = currentValue.split(',').filter(val => val !== value).join(',');
    }

    // Update the field's value with the new comma-separated string
    const updatedFormData = [...formData.component.formFields];
    updatedFormData[index].value = newValue;
    setFormData({ ...formData, component: { ...formData.component, formFields: updatedFormData } });
  };
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Tele Verification Form
        {formData?.attachmentUrl ? (
                                <a 
                                    href={formData?.attachmentUrl} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    style={{ textDecoration: "none" }}
                                >
                                    <FaPaperclip />
                                </a>
                            ) : (
                                ""
                            )}
      </h2>
      <div className="mb-4">
      <div className="max-w-4xl mx-auto p-6 shadow-md rounded-lg p-4 bg-blue-100  rounded-md">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div><label className="text-blue-900 font-semibold">Checkin ID: <span className="text-gray-900 font-medium ml-2">{responseData?.checkinId}</span></label> </div>
            <div><label className="text-blue-900 font-semibold">Created On: <span className="text-gray-900 font-medium ml-2">{responseData?.createdDate}</span></label> </div>
          </div>
          <div><label className="text-blue-900 font-semibold">Customer Name: <span className="text-gray-900 font-medium ml-2">{responseData?.customerName}</span></label> </div>
          <div><label className="text-blue-900 font-semibold">Contact Number: <span className="text-gray-900 font-medium ml-2">{responseData?.contactNumber}</span></label> </div>
          <div><label className="text-blue-900 font-semibold">Co Applicant Name: <span className="text-gray-900 font-medium ml-2">{responseData?.candidateDetails?.coApplicant}</span></label> </div>
          <div><label className="text-blue-900 font-semibold">Customer Address: <span className="text-gray-900 font-medium ml-2">{responseData?.address}</span></label> </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div><label className="text-blue-900 font-semibold">Service Type: <span className="text-gray-900 font-medium ml-2">{selectedFileDetails?.serviceType}</span></label> </div>
            <div><label className="text-blue-900 font-semibold">Field Officer: <span className="text-gray-900 font-medium ml-2">{selectedFileDetails?.fieldOfficerName}</span></label> </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div><label className="text-blue-900 font-semibold">Date Of Birth: <span className="text-gray-900 font-medium ml-2">{responseData?.candidateDetails?.dateOfBirth}</span></label> </div>
            <div><label className="text-blue-900 font-semibold">Bank Name: <span className="text-gray-900 font-medium ml-2">{responseData?.customerSubAdditionalDetails?.bankName}</span></label> </div>
          </div>
        </div>
      </div>
      <div>
      
      <form className="space-y-6">
        {/* {fields.map((field) => ( */}
        {formData?.component?.formFields?.length > 0 ? (
          formData.component.formFields.map((field, index) => (
            isFieldVisible(field) && (
              <div key={field.fieldId} className="space-y-2">
                <label className="block text-gray-700 font-medium" htmlFor={field.fieldName}>
                  {field.fieldLabel}
                  {field.required ? (
                    <span className="text-red-500"> *</span>
                  ) : ""}
                </label>
                {(field.fieldType === 'select' || field.fieldType === 'radio') && field.hasOptions ? (
                  <div><select
                    id={field.fieldName}
                    name={field.fieldName}
                    required={field.required}
                    onChange={(e) => handleChange(e, index)}
                    value={field.value || ""}
                    className={`w-full px-3 py-2 border ${errors[field.fieldName] ? "border-red-500" : "border-gray-300"
                      } rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500`}
                  >
                    <option value="">Select</option>
                    {field.options.map((option) => (
                      <option key={option.optionValue} value={option.optionValue}>
                        {option.optionLabel}
                      </option>
                    ))}
                  </select>
                    {errors[field.fieldName] && (
                      <p className="text-red-500 text-sm">{errors[field.fieldName]}</p>
                    )}
                  </div>
                ) : field.fieldType === 'checkbox' ? (
                  <div>
                    {field.options.map((option) => (
                      <div>
                        <div key={option.optionValue} className="flex items-center space-x-2">
                          <input
                            id={option.optionValue}
                            type="checkbox"
                            name={field.fieldName}
                            value={option.optionValue}
                            checked={field.value?.split(',').includes(option.optionValue) || false}  // Split the value into array for checking
                            onChange={(e) => handleCheckboxChange(e, index)}  // Call the new handler function
                            className={`h-5 w-5 text-blue-600 border ${errors[field.fieldName] ? "border-red-500" : "border-gray-300"
                              } rounded focus:ring-blue-500`}
                          />
                          <label htmlFor={option.optionValue} className="text-gray-700 font-medium">
                            {option.optionLabel}
                          </label>
                        </div>

                      </div>
                    ))}
                    {errors[field.fieldName] && (
                      <p className="text-red-500 text-sm">{errors[field.fieldName]}</p>
                    )}
                  </div>
                ) : field.fieldType === 'textarea' ? (
                  <div><textarea
                    id={field.fieldName}
                    name={field.fieldName}
                    required={field.required}
                    onChange={(e) => handleChange(e, index)}
                    value={field.value || ""}
                    className={`w-full px-3 py-2 border ${errors[field.fieldName] ? "border-red-500" : "border-gray-300"
                      } rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500`}
                      style={{ textTransform: 'uppercase' }} // Ensure text is displayed in uppercase
                  />
                    {errors[field.fieldName] && (
                      <p className="text-red-500 text-sm">{errors[field.fieldName]}</p>
                    )}
                  </div>
                ) : field.fieldType === 'text' ? (
                  <div><input
                    id={field.fieldName}
                    type={field.fieldType}
                    name={field.fieldName}
                    required={field.required}
                    onChange={(e) => handleChange(e, index)}
                    value={field.value || ""}
                    className={`w-full px-3 py-2 border ${errors[field.fieldName] ? "border-red-500" : "border-gray-300"
                      } rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500`}
                      style={{ textTransform: 'uppercase' }} // Ensure text is displayed in uppercase
                  />
                    {errors[field.fieldName] && (
                      <p className="text-red-500 text-sm">{errors[field.fieldName]}</p>
                    )}
                  </div>
                ) : field.fieldType === 'number' ? (
                  <div><input
                    id={field.fieldName}
                    type={field.fieldType}
                    name={field.fieldName}
                    required={field.required}
                    onChange={(e) => handleChange(e, index)}
                    value={field.value || ""}
                    className={`w-full px-3 py-2 border ${errors[field.fieldName] ? "border-red-500" : "border-gray-300"
                      } rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500`}
                      style={{ textTransform: 'uppercase' }} // Ensure text is displayed in uppercase
                  />{errors[field.fieldName] && (
                    <p className="text-red-500 text-sm">{errors[field.fieldName]}</p>
                  )}
                  </div>) : field.fieldType === 'date' ? (
                    <div><input
                      id={field.fieldName}
                      type={field.fieldType}
                      name={field.fieldName}
                      required={field.required}
                      onChange={(e) => handleChange(e, index)}
                      value={field.value || ""}
                      className={`w-full px-3 py-2 border ${errors[field.fieldName] ? "border-red-500" : "border-gray-300"
                        } rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500`}
                    />{errors[field.fieldName] && (
                      <p className="text-red-500 text-sm">{errors[field.fieldName]}</p>
                    )}
                    </div>) : ''}
              </div>
            )

          ))


        ) : (
          <p>Loading...</p>
        )
        }
        <label className="block text-gray-700 font-medium" >
          Remarks
        </label>
        <textarea
          id={formData.fieldExecutiveRemarks}
          name={formData.fieldExecutiveRemarks}
          onChange={(e) => {
            setFormData((prevFormData) => ({
              ...prevFormData,

              fieldExecutiveRemarks: e.target.value
            }))
          }}
          value={formData.fieldExecutiveRemarks || ""}
          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          style={{ textTransform: 'uppercase' }} // Ensure text is displayed in uppercase
        />
        <div>
          <h3 className="text-xl font-semibold text-gray-800 mt-6">Tele-Calling Logs</h3>
          <div className="grid grid-cols-7 gap-4 items-center mb-4">
            <label className="font-medium">Attempt</label>
            <label className="font-medium">Date (Resi)</label>
            <label className="font-medium">Time (Resi)</label>
            <label className="font-medium">Outcome (Resi)</label>
            <label className="font-medium">Date (Office)</label>
            <label className="font-medium">Time (Office)</label>
            <label className="font-medium">Outcome (Office)</label>
          </div>
          {teleLogs.map((log, index) => (
            <div key={index} className="grid grid-cols-7 gap-4 items-center mb-4">
              <div>{log.attempt}</div>
              <input
                type="text"
                name="resi_date"
                value={log.resi_date}
                onChange={(e) => handleTeleLogChange(index, e)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none"
                style={{ textTransform: 'uppercase' }} // Ensure text is displayed in uppercase
              />
              <input
                type="text"
                name="resi_time"
                value={log.resi_time}
                onChange={(e) => handleTeleLogChange(index, e)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none"
                style={{ textTransform: 'uppercase' }} // Ensure text is displayed in uppercase
              />
              <input
                type="text"
                name="resi_outcome"
                placeholder="Outcome"
                value={log.resi_outcome}
                onChange={(e) => handleTeleLogChange(index, e)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none"
                style={{ textTransform: 'uppercase' }} // Ensure text is displayed in uppercase
              />

              <input
                type="text"
                name="office_date"
                value={log.office_date}
                onChange={(e) => handleTeleLogChange(index, e)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none"
                style={{ textTransform: 'uppercase' }} // Ensure text is displayed in uppercase
              />
              <input
                type="text"
                name="office_time"
                value={log.office_time}
                onChange={(e) => handleTeleLogChange(index, e)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none"
                style={{ textTransform: 'uppercase' }} // Ensure text is displayed in uppercase
              />
              <input
                type="text"
                name="office_outcome"
                placeholder="Outcome"
                value={log.office_outcome}
                onChange={(e) => handleTeleLogChange(index, e)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none"
                style={{ textTransform: 'uppercase' }} // Ensure text is displayed in uppercase
              />
              {/* <button type='button'
            onClick={() => deleteLog(index)}
            className="text-white bg-red-500 hover:bg-red-600 px-3 py-2 rounded-md shadow-sm focus:outline-none"
          >
            Delete
          </button> */}
            </div>
          ))}
          {/* <button type='button'
        onClick={() => addLog()}
        className="mt-4 text-white bg-blue-500 hover:bg-blue-600 px-4 py-2 rounded-md shadow-sm focus:outline-none"
      >
        Add New Log
      </button> */}
        </div>



        <div>
          <h3 className="text-xl font-semibold text-gray-800 mt-6">Tele-Calling Logs(Post)</h3>
          <div className="grid grid-cols-7 gap-4 items-center mb-4">
            <label className="font-medium">Attempt </label>
            <label className="font-medium">Date (Resi)</label>
            <label className="font-medium">Time (Resi)</label>
            <label className="font-medium">Outcome (Resi)</label>
            {/* <label className="font-medium">Date (Office)</label>
        <label className="font-medium">Time (Office)</label>
        <label className="font-medium">Outcome (Office)</label> */}
          </div>

          {postTeleLogs.map((postlog, index) => (
            <div key={index} className="grid grid-cols-7 gap-4 items-center mb-4">
              <div>{postlog.attempt}</div>
              <input
                type="text"
                name="resi_date"
                value={postlog.resi_date}
                onChange={(e) => handlePostTeleLogChange(index, e)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none"
                style={{ textTransform: 'uppercase' }} // Ensure text is displayed in uppercase  
              />
              <input
                type="text"
                name="resi_time"
                value={postlog.resi_time}
                onChange={(e) => handlePostTeleLogChange(index, e)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none"
                style={{ textTransform: 'uppercase' }} // Ensure text is displayed in uppercase  
              />
              <input
                type="text"
                name="resi_outcome"
                placeholder="Outcome"
                value={postlog.resi_outcome}
                onChange={(e) => handlePostTeleLogChange(index, e)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none"
                style={{ textTransform: 'uppercase' }} // Ensure text is displayed in uppercase  
              />

              {/* <button type='button'
            onClick={() => deletePostLog(index)}
            className="text-white bg-red-500 hover:bg-red-600 px-3 py-2 rounded-md shadow-sm focus:outline-none"
          >
            Delete
          </button> */}
            </div>
          ))}
          {/* <button type='button'
        onClick={() => addPostLog()}
        className="mt-4 text-white bg-blue-500 hover:bg-blue-600 px-4 py-2 rounded-md shadow-sm focus:outline-none"
      >
        Add New Log
      </button> */}
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-9 gap-4 items-center mb-4">
  <button
    type="button"
    className="w-full sm:w-auto px-4 py-2 bg-green-500 text-white font-semibold rounded-md shadow-md hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500"
    onClick={handleSave}
  >
    Save
  </button>

  <button
    type="button"
    className="w-full sm:w-auto px-4 py-2 bg-green-500 text-white font-semibold rounded-md shadow-md hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500"
    onClick={handleSubmit}
  >
    Submit
  </button>
</div>

      </form>
      </div>
      {/* Display the overlay when processing */}
      <ProcessingOverlay isProcessing={isProcessing} message="Please wait, we're processing your request..." />
    </div>
  );
};

export default DynamicForm_TE;
